//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchDetail } from '@/api/PMS/baseInformation/garageoa';
export default {
  props: ['keyValue', 'showDialog'],
  data: function data() {
    return {
      areaId: '',
      childData: {}
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.init();
      }
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;

      if (this.keyValue > 0) {
        var queryData = {
          id: this.keyValue
        };
        fetchDetail(queryData).then(function (response) {
          _this.childData = response.data.data;
        });
      }
    },
    handleAdd: function handleAdd() {
      this.$emit('handDetailCancle', 'add');
    },
    handleEdit: function handleEdit() {
      this.$emit('handDetailCancle', 'edit');
    }
  }
};